const animations = () => {
    const animationConfigs = [
        {
            container: 'features-circles-anim',
            element: 'features-circles__item',
            classAnimEnd: 'bounceInRight'
        },
        {
            container: 'text-block_two-columns-anim',
            element: 'text-container:nth-child(1)',
            classAnimEnd: 'bounceInLeft'
        },
        {
            container: 'text-block_two-columns-anim',
            element: 'text-container:nth-child(2)',
            classAnimEnd: 'bounceInRight'
        },
        {
            container: 'features-anim',
            element: 'features__item',
            classAnimEnd: 'fadeIn'
        }
    ];

    animationConfigs.forEach(config => animateElements(config));
};

// Функция для применения анимаций
const animateElements = ({
                             container, // класс контейнера, на который ставится наблюдатель
                             element, // класс анимируемого эл-та (добавить ему visibility: hidden)
                             classAnimStart, // класс начальной точки анимации (при keyframes он не нужен)
                             classAnimEnd, // класс конечной точки анимации
                             threshold = window.innerWidth <= 768 ? 0 : 0.25, // допустимый процент пересечения контейнера, когда начнется анимация
                             // (на мобильниках начинаем анимацию сразу же: threshold = 0)
                             once = false // проиграть анимацию только 1 раз
                         }) => {

    const handleIntersection = (entries, observer) => {
        entries.forEach(({ target, isIntersecting }) => {
            const elements = target.querySelectorAll(`.${element}`);
            elements.forEach(el => {
                if (classAnimStart) {
                    el.classList.add(classAnimStart);
                }

                setTimeout(() => {
                    if (once) {
                        if (isIntersecting) {
                            el.classList.add(classAnimEnd);
                        }
                    } else {
                        el.classList.toggle(classAnimEnd, isIntersecting);
                    }
                }, 100);
            });
        });
    };

    const observer = new IntersectionObserver(handleIntersection, { threshold });
    document.querySelectorAll(`.${container}`).forEach(containerElement => observer.observe(containerElement));
};

export default animations;